import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {SectionModel} from '../../models/section';
import HomeConfig = SectionModel.HomeConfig;
import {map} from 'rxjs/operators';
import {Repository} from '@app/@core/repositories/repository';

@Injectable({
  providedIn: 'root'
})
export class HomeConfigRepository extends Repository<HomeConfig>{
    constructor(http: HttpClient) {
        super(http, 'homeConfig');
    }

    upsert(model: HomeConfig): Observable<HomeConfig> {
        if (model.id) {
            return this.http.post<any>(`${environment.apiUrl}/api/homeConfig/${model.id}`, model).pipe(map(rs => rs.model));
        } else {
            return this.http.post<any>(`${environment.apiUrl}/api/homeConfig`, model).pipe(map(rs => rs.model));
        }
    }

    publish(id: string): Observable<HomeConfig> {
        return this.http.put<any>(`${this.entityUrl}/${id}/live`, null).pipe(map(rs => rs.model));
    }
}
